module.exports = __webpack_public_path__ + "d99b03e764aee44b0935f2ae1f9a9fe4.svg";